import { IAppState } from '../../redux';

export function selectIsPackagesAvailable(state: IAppState): boolean {
  const { packageIds } = state.publishTerms;

  return packageIds.length > 0;
}
